import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons'
import styles from './EmptyState.module.scss'

/**
 * Универсальный пустой стейт для списков/таблиц/страниц без данных.
 * Использование:
 *   <EmptyState
 *     iconName="folder"
 *     title="Пока нет данных"
 *     description="Создайте первую запись"
 *     action={<button onClick={...}>Создать</button>}
 *   />
 */
const EmptyState = ({
  iconName = 'folder',
  iconSize = 48,
  title,
  description = '',
  action = null,
  variant = 'default',
}) => {
  const { t } = useTranslation('common')
  const resolvedTitle = title ?? t('auto.unvui_emptystate.title', 'Пусто')
  return (
    <div className={`${styles.empty} ${styles[variant] || ''}`} role="status" aria-live="polite">
      <div className={styles.iconBox}>
        <Icon name={iconName} size={iconSize} color="var(--color-accent)" strokeWidth={1.5} />
      </div>
      <h3 className={styles.title}>{resolvedTitle}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  )
}

export default EmptyState
